module.exports = __webpack_public_path__ + "img/higgs_module_1_img4.89f13577.gif";